import * as PIXI from "pixi.js";
import { BULLET_SPEED, DEBUG } from "./constants";

export class Bullet {
	public sprite: PIXI.Sprite;
	public speed: number;
	public angle: number;
	public ax: number;
	public ay: number;
	public graphics: PIXI.Graphics;

	constructor(x: number, y: number, tx: number, ty: number) {
		this.sprite = new PIXI.Sprite(
			PIXI.Loader.shared.resources["img/player/p_bullet.png"].texture
		);
		this.sprite.anchor.set(0.5);
		this.sprite.x = x;
		this.sprite.y = y;

		// Don't go below horizontal
		if (ty > y) {
			ty = y;
		}

		this.angle = Math.atan((ty - this.sprite.y) / (tx - this.sprite.x));
		this.ax = Math.cos(this.angle);
		this.ay = Math.sin(this.angle);
		this.speed = BULLET_SPEED;
		this.graphics = new PIXI.Graphics();
	}

	update() {
		if (Math.sign(this.angle) == 1 || Object.is(Math.sign(this.angle), -0)) {
			this.sprite.x -= this.speed * this.ax;
			this.sprite.y -= this.speed * this.ay;
		} else {
			this.sprite.x += this.speed * this.ax;
			this.sprite.y += this.speed * this.ay;
		}

		if (DEBUG) {
			this.graphics.clear();
			this.graphics.lineStyle(2, 0x00ff00); // (thickness, color)
			this.graphics.drawRect(
				this.sprite.x - this.sprite.width / 2,
				this.sprite.y - this.sprite.height / 2,
				this.sprite.width,
				this.sprite.height
			);
			this.graphics.endFill();
		}
	}

	pointDistanceFrom(
		xSource: number,
		ySource: number,
		xTarget: number,
		yTarget: number,
		distance: number
	) {
		const distanceToTarget = Math.sqrt(
			Math.pow(xTarget - xSource, 2) + Math.pow(yTarget - ySource, 2)
		);
		const xFinal =
			xSource + (distance * (xTarget - xSource)) / distanceToTarget;
		const yFinal =
			ySource + (distance * (yTarget - ySource)) / distanceToTarget;

		return [xFinal, yFinal];
	}
}
